/* eslint semi: "error" */
/* eslint-disable */
var echarts = require('echarts/lib/echarts');

let colorStr = '#50ECEE';

export const getOptionConfig = (category, barData, lang) => {
  let clientHeight = document.body.clientHeight;
  let option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: '2%',
      right: '2%',
      bottom: '3%',
      top:'10%',
      containLabel: true
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      axisLabel: {
        color: colorStr
      },
      axisLine: {
        lineStyle: {
          color: colorStr
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: [colorStr],
          width: 0.5,
          type: 'dashed'
        }
      }
    },
    yAxis: {
      type: 'category',
      data: category,
      axisLine: {
        lineStyle: {
          color: colorStr
        }
      },
      axisLabel: {
        color: colorStr
      }
    },
    series: [
      {
        type: 'bar',
        data: barData,
        barWidth: clientHeight < 900 ? 7 : 14,
        itemStyle: {
          emphasis: {
            barBorderRadius: 7
          },
          normal: {
            barBorderRadius: 2,
            color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
              { offset: 0, color: '#00ffc800'},
              { offset: 1, color: '#00FAC8' }
            ])
          }
        }
      }
    ]
  };
  return option;
};





// WEBPACK FOOTER //
// ./src/modules/tenantManager/dashboard/deviceTypeChart/barChar.js